import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useT } from '../utils/i18n';
export function WhyUs() {
  const t = useT();
  return <section className="py-12 md:py-16 dark:bg-[#000000] transition-colors duration-300 border-t border-stone-200 dark:border-[#202020] relative overflow-hidden bg-[#ffffff]" id="why-us" data-id="element-1901" data-mp="17kho7f462ym2">
      {/* Subtle decorative accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-orange/40 to-transparent" data-id="element-1902" data-mp="1gmh4u6b9s0oh" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 font-[Roboto,_sans-serif]" data-id="element-1903" data-mp="1qibs5eqfujxl">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="grid lg:grid-cols-12 gap-6 lg:gap-12 items-end" data-id="element-1904" data-mp="1ljh8ybok6tcy">
          <div className="lg:col-span-6" data-id="element-1905" data-mp="3ebl0v4ilsabp">
            <div className="inline-flex items-center gap-2 mb-3" data-id="element-1906" data-mp="3e8p078fdf7jk">
              <MapPin className="w-3.5 h-3.5 text-[#199A6E]" data-id="element-1907" data-mp="3jaxtk5w5obm7" />
              <span className="font-bold uppercase tracking-[0.14em] text-[12px] text-[#199A6E] font-[Montserrat,_sans-serif]" data-id="element-1908" data-mp="3nbq7hcfz34ot">
                {'Local Experts'}
              </span>
            </div>

            <h2 className="text-[40px] sm:text-4xl md:text-5xl lg:text-6xl font-black text-stone-900 dark:text-white tracking-tight leading-[1.05]" data-id="element-1909" data-mp="w5fb3ilkowx">
              <span className="font-[Lato,_sans-serif] text-[#00754A]" data-id="element-1910" data-mp="5tf3kfu92uj6">
                We're the dispatcher.
              </span>
              <span className="font-sub text-[#00754A]" style={{
              WebkitTextStrokeWidth: '0px',
              WebkitTextStrokeColor: '#508865',
              WebkitTextFillColor: '#00754A'
            }} data-id="element-1911" data-mp="as8jeex0exmi">
                We're the driver.
              </span>{' '}
              <span className="font-[Montserrat,_sans-serif] text-[#00754A]" data-id="element-1912" data-mp="2gmhzi9m6tzch">
                We are local.
              </span>
            </h2>
          </div>

          <div className="lg:col-span-6 lg:pl-6 lg:border-l lg:border-stone-200 dark:lg:border-white/10 pt-[10px] pb-[10px]" data-id="element-1913" data-mp="3jzs0j8403fvu">
            <p className="dark:text-stone-200 text-base md:text-lg leading-relaxed mb-4 text-stone-900 font-[400] font-[Inter,_sans-serif]" data-id="element-1914" data-mp="3sydc2jb21un4">
              {"Built in the 253, we're on the road across the 206 and 425 daily, delivering gravel, soil, bark, and landscape materials throughout King and Pierce Counties.  Same trucks, same drivers, same dispatcher every load.  \nWhen you call, you're talking directly to the people who will schedule and deliver your materials\u2014giving you better service and dependable local delivery every time.."}
            </p>
            <Link to="/local-vs-national" className="group inline-flex items-center gap-2 text-brand-orange hover:text-brand-orange/80 font-bold text-sm tracking-tight transition-colors" data-id="element-1915" data-mp="bk8asj2jgflj">
              <span className="text-stone-700 dark:text-stone-200 group-hover:text-brand-orange transition-colors text-[16px] font-[600] font-[Inter,_sans-serif]" data-id="element-1916" data-mp="kkmytq6w08sq">
                See how we stack up vs. national marketplaces
              </span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1 shrink-0" data-id="element-1917" data-mp="v4gm7e60mtgp" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}